import { Box, Button } from '@mui/material';
import React from 'react';
import { lightBackgroundButtonStyles } from '../../styles/button';
import { ResponsiveTypography } from '../../styles/inputLabel';

interface GuideButtonProps {
  links: string[];
  icons: React.ReactNode[];
  labels: string[];
}

export default function GuideButton({
  links,
  icons,
  labels,
}: GuideButtonProps) {
  return (
    <Box display="flex" flexDirection="column" gap="1rem" py="1rem">
      <ResponsiveTypography>Guide</ResponsiveTypography>
      <Box display="flex" flexDirection="row" gap="1rem">
        {links.map((link, index) => (
          <Button
            key={link}
            startIcon={icons[index] ?? null}
            sx={{
              ...lightBackgroundButtonStyles,
              width: {
                xxl: '12rem',
                xl: '10rem',
                lg: '8rem',
                md: '6rem',
              },
            }}
            onClick={() => link && window.open(link, '_blank')}
          >
            {labels[index]}
          </Button>
        ))}
      </Box>
    </Box>
  );
}
